import { Row } from 'app/design/primitives/box';
import { getLocalCacheForImage } from 'app/design/primitives/image';
import ImageViewerModal from 'app/design/primitives/image-viewer-modal';
import { Thumbnail } from 'app/design/primitives/thumbnail';
import { type Profile } from 'app/network/profile';
import React from 'react';
import { Pressable, View } from 'react-native';
import { theme } from './theme';
import { ProfileIdentity } from './profile-identity';
import { ProfileHeroSkeleton } from './profile-hero-skeleton';

export function ProfileHero({
  badge,
  isImageViewerModalOpen,
  isUnavailable,
  onCloseImage,
  onOpenAmbassador,
  onOpenImage,
  profile,
  showSuperPartageur,
  subscribed,
  trustPoints,
  viewedProfileIsAmbassador,
}: {
  badge: React.ReactElement;
  isImageViewerModalOpen: boolean;
  isUnavailable: boolean;
  onCloseImage: () => void;
  onOpenAmbassador: () => void;
  onOpenImage: () => void;
  profile: Profile | undefined;
  showSuperPartageur: boolean;
  subscribed?: boolean | null;
  trustPoints?: number;
  viewedProfileIsAmbassador: boolean;
}) {
  if (!profile) return <ProfileHeroSkeleton />;
  const avatarSize = profile.placeDetails ? 88 : 72;
  return (
    <Row
      alignItems={profile.placeDetails ? 'center' : 'flex-start'}
      style={profile.placeDetails ? { marginBottom: theme.spacing['spacing.general.x3'] } : undefined}
    >
      <View style={{ height: avatarSize, width: avatarSize }}>
        <Pressable onPress={onOpenImage}>
          <Thumbnail height={avatarSize} source={{ uri: profile.picture }} useOwnCache badge={badge} />
        </Pressable>
        {profile.picture ? (
          <ImageViewerModal
            imageUrls={[{ url: getLocalCacheForImage(profile.picture) ?? profile.picture }]}
            onClose={onCloseImage}
            open={isImageViewerModalOpen}
          />
        ) : null}
      </View>
      <ProfileIdentity
        isUnavailable={isUnavailable}
        onOpenAmbassador={onOpenAmbassador}
        profile={profile}
        showSuperPartageur={showSuperPartageur}
        trustPoints={trustPoints}
        subscribed={subscribed}
        viewedProfileIsAmbassador={viewedProfileIsAmbassador}
      />
    </Row>
  );
}
